const BlueprintModalWorkers = () => {
  return <div>Workers</div>;
};

export default BlueprintModalWorkers;
